// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./GameOver.css')));

var component = ReasonReact.statelessComponent("Result");

function make(gameOver, score, onReplay, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      if (gameOver !== 0) {
        return React.createElement("div", {
                    className: "end_layer"
                  }, React.createElement("div", {
                        className: "message"
                      }, "Game Over!"), React.createElement("div", {
                        className: "scoreArea center"
                      }, React.createElement("div", {
                            className: "scoreAreaInner center"
                          }, React.createElement("div", {
                                className: "scoreLabel"
                              }, "Score"), React.createElement("div", {
                                className: "score"
                              }, Pervasives.string_of_int(score)))), React.createElement("div", {
                        className: "to_github"
                      }, React.createElement("a", {
                            className: "github_link",
                            href: "https://github.com/sevenseat/rr-2048"
                          }, "Star this project on github")), React.createElement("div", {
                        className: "replay"
                      }, React.createElement("button", {
                            className: "replay-button",
                            id: "replay",
                            onClick: onReplay
                          }, "Try again")));
      } else {
        return null;
      }
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/GameOver.re
// module id = 34
// module chunks = 0